module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#user",
      toString: function () {
        return this.url;
      }
    }